module.exports = __webpack_public_path__ + "img/hlj.cad43729.jpg";